export default "__VITE_ASSET__tEzlIyKO__"